import { ArrowLeft, CreditCard, ShieldCheck, Info } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MainNavbar } from '../../components/navigation/MainNavbar';
import useWalletData from '../../hooks/useWalletData';

export default function DepositAccountPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { depositTotals } = useWalletData(true);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-slate-950">
      <MainNavbar />

      <section className="pt-32 pb-8">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <button
            onClick={() => navigate('/wallet')}
            className="inline-flex items-center gap-2 text-gray-600 dark:text-slate-400 text-sm font-semibold mb-6 hover:text-gray-900 dark:hover:text-white transition"
          >
            <ArrowLeft className="h-4 w-4" />
            {t('wallet.allTransactions.backToWallet')}
          </button>
          <div className="rounded-3xl bg-white dark:bg-slate-900 p-8 shadow-lg border border-gray-100 dark:border-slate-800 space-y-6">
            <div className="flex items-center gap-4">
              <div className="h-14 w-14 rounded-2xl bg-emerald-100 dark:bg-emerald-900/20 text-emerald-600 dark:text-emerald-400 flex items-center justify-center">
                <CreditCard className="h-6 w-6" />
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-500 dark:text-slate-400 uppercase tracking-[0.3em]">
                  {t('wallet.depositAccount.depositMethod')}
                </p>
                <h1 className="text-3xl font-black text-gray-900 dark:text-white">
                  {t('wallet.depositAccount.title')}
                </h1>
              </div>
            </div>

            <p className="text-gray-600 dark:text-slate-400 leading-7">
              {t('wallet.depositAccount.description')}
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="rounded-2xl border border-gray-100 dark:border-slate-800 p-4">
                <p className="text-sm font-semibold text-gray-500 dark:text-slate-400 uppercase tracking-widest mb-1">
                  {t('wallet.depositAccount.cardsSupported')}
                </p>
                <p className="text-lg font-semibold text-gray-900 dark:text-white">
                  {t('wallet.depositAccount.cardsList')}
                </p>
              </div>
              <div className="rounded-2xl border border-gray-100 dark:border-slate-800 p-4">
                <p className="text-sm font-semibold text-gray-500 dark:text-slate-400 uppercase tracking-widest mb-1">
                  {t('wallet.totalDeposits')}
                </p>
                <p className="text-lg font-semibold text-gray-900 dark:text-white">
                  {t('wallet.depositsCount', { count: depositTotals.count })}
                </p>
              </div>
            </div>

            <div className="rounded-2xl border border-gray-100 dark:border-slate-800 bg-gray-50 dark:bg-slate-800 p-4 flex items-start gap-3 text-sm text-gray-700 dark:text-slate-300">
              <ShieldCheck className="h-5 w-5 text-emerald-500 dark:text-emerald-400 mt-0.5" />
              <p>
                {t('wallet.depositAccount.securityNote')}
              </p>
            </div>

            <div className="rounded-2xl border border-dashed border-gray-200 dark:border-slate-700 p-4 flex items-start gap-3 text-sm text-gray-600 dark:text-slate-400 bg-white dark:bg-slate-900">
              <Info className="h-5 w-5 text-gray-400 dark:text-slate-500 mt-0.5" />
              <p>
                {t('wallet.depositAccount.infoNote')}
              </p>
            </div>

            <div className="flex justify-end">
              <button
                onClick={() => navigate('/wallet/add')}
                className="rounded-2xl bg-black dark:bg-slate-700 px-5 py-3 text-sm font-semibold text-yellow-400 transition hover:bg-gray-900 dark:hover:bg-slate-800"
              >
                {t('wallet.depositAccount.makeDeposit')}
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
